import { render, staticRenderFns } from "./WeRoundedPicture.vue?vue&type=template&id=1d95f362&"
import script from "./WeRoundedPicture.vue?vue&type=script&lang=js&"
export * from "./WeRoundedPicture.vue?vue&type=script&lang=js&"
import style0 from "./WeRoundedPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
